import { generateColorsHelp } from './includes/colors_help'
import { entranceStyle, generateEntrance } from './includes/entrance'
import { generatePolygons, polygonStyleFunction, specialStyleFunction } from './includes/generate_polygons'
import { showPopup } from './includes/show_popup'
import { showTip } from './includes/show_tip'
import { initGlobal } from '@js/_common.ts'
// import jQuery from 'jquery'
import { Overlay } from 'ol'
import { pointerMove } from 'ol/events/condition'
import { getCenter } from 'ol/extent'
import { Select } from 'ol/interaction'
import ImageLayer from 'ol/layer/Image'
import Map from 'ol/Map'
import Projection from 'ol/proj/Projection'
import Static from 'ol/source/ImageStatic'
import View from 'ol/View'

initGlobal().then(() => {
  ;(function ($) {
    $(function () {
      const $paragraph = $('.paragraph--type--interaktivnaya-karta')
      const $mapContainer = $('.map-container', $paragraph)
      const img = $('.field--name-field-map-bg img', $paragraph)

      const imgWidthString = img.attr('width')
      const imgWidth = imgWidthString ? Number.parseInt(imgWidthString, 10) : 0
      const imgHeightString = img.attr('height')
      const imgHeight = imgHeightString ? Number.parseInt(imgHeightString, 10) : 0
      const imgSource = img.attr('src')

      if ($mapContainer && imgWidth && imgHeight && imgSource) {
        // Map views always need a projection.  Here we just want to map image
        // coordinates directly to map coordinates, so we create a projection that uses
        // the image extent in pixels.
        const extent = [0, 0, imgWidth, imgHeight]
        const projection = new Projection({
          code: 'map',
          units: 'pixels',
          extent,
        })

        const $popup = $(`<section class="map-popup">
                                <header class="map-popup__header">
                                    <div class="map-popup__header-content"></div>
                                    <a href="#" class="map-popup__closer" title="Закрыть"></a>
                                </header>
                                <div class="map-popup__content"></div>
                              </section>`).appendTo($mapContainer)

        /**
         * Create an overlay to anchor the popup to the map.
         */
        const overlay = new Overlay({
          element: $popup[0],
          autoPan: {
            animation: {
              duration: 250,
            },
          },
        })

        $popup.find('.map-popup__closer').on('click', function (event) {
          event.preventDefault()
          overlay.setPosition(undefined)
          this.blur()
        })
        const $tip = $('<aside class="map-tip"></aside>').appendTo($mapContainer)

        // eslint-disable-next-line promise/prefer-await-to-then
        generatePolygons($, imgHeight).then((generated) => {
          generateColorsHelp($, $mapContainer, generated.data)

          const map = new Map({
            layers: [
              new ImageLayer({
                source: new Static({
                  url: imgSource,
                  projection,
                  imageExtent: extent,
                }),
                visible: true,
              }),
              generated.vectorLayer,
              generated.specialLayer,
              generateEntrance(generated.data.entrance, imgHeight),
            ],
            overlays: [overlay],
            target: $mapContainer[0],
            view: new View({
              projection,
              extent,
              center: getCenter(generated.featuresExtent),
              minZoom: 1,
              zoom: 2,
              maxZoom: 8,
            }),
          })
          map.getView().fit(generated.featuresExtent, {
            size: map.getSize(),
            maxZoom: 2,
            padding: [30, 30, 30, 30],
          })

          const select = new Select({
            condition: pointerMove,
            style(feature, resolution) {
              switch (feature.get('type')) {
                case 'Entrance':
                  return entranceStyle
                case 'Special':
                  return specialStyleFunction(feature, resolution, true)
                default:
                  return polygonStyleFunction(feature, resolution, true)
              }
            },
          })

          map.addInteraction(select)

          showPopup(map, $popup, overlay, generated.data)
          showTip(map, $tip, generated.data)
        })
      }
    })
  })(jQuery)
})
